import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ModuleManagersService } from 'app/library/module-managers/services/module-managers.service';
import { ModuleUserProgressStatus } from 'app/library/module-user/enums/module-user-progress-status.enum';
import { ModuleCompletitionStatuses } from 'app/library/module-user/models/module-completition-status';
import { ModuleKind } from 'app/library/module/enums/module-kind.enum';
import { ModuleCategory } from 'app/library/module/enums/moduleCategory';
import { SectionRule } from 'app/library/module/enums/sectionRule.enum';
import { ModuleKinds } from 'app/library/module/models/module-kinds';
import { Module } from 'app/library/module/models/module.model';
import { ModuleGlobalService } from 'app/library/module/services/module-global.service';
import { ProgramItem } from 'app/library/program-item/models/program-item.model';
import { RelevantExecution } from 'app/library/program-item/models/relevant-execution.model';
import { ProgramItemService } from 'app/library/program-item/services/program-item.service';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { User } from 'app/projects/user/src/lib/models/user';
import { Team } from 'app/library/team/models/team.model';

@Component({
    selector: 'app-my-course-card',
    templateUrl: './my-course-card.component.html',
    styleUrls: ['./my-course-card.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class MyCourseCardComponent extends UnsubscribeOnDestroy {
    @Input()
    programItem: ProgramItem;

    @Input()
    unsplashViewsBaseUrl: string;

    @Input()
    module: Module;

    @Input()
    team: Team;

    @Input()
    user: User;

    @Input()
    bgColor: string;

    @Input()
    isTeamProgramMemberDialog: boolean;

    @Input()
    isCurrentUserTenantAdmin: boolean;

    @Input()
    participantId?: string;

    ModuleKind = ModuleKind;
    ModuleCategory = ModuleCategory;
    moduleKinds = ModuleKinds;
    moduleCompletitionStatus = ModuleCompletitionStatuses;
    SectionRule = SectionRule;
    ModuleUserProgressStatus = ModuleUserProgressStatus;

    constructor(private _moduleGlobalService: ModuleGlobalService, private _moduleManagersService: ModuleManagersService, public programItemService: ProgramItemService) {
        super();
    }

    async navigateToExecution(relevantExecution: RelevantExecution) {
        if (
            relevantExecution.status === ModuleCategory.Archived ||
            relevantExecution.status === ModuleCategory.Unpublished ||
            (this.isTeamProgramMemberDialog && relevantExecution.kind !== ModuleKind.ProgramExecution)
        ) {
            return;
        }

        if (this.isTeamProgramMemberDialog) {
            await this.programItemService.fetchTeamParticipantProgramExecution(this.team.id, relevantExecution.id, this.participantId);
        } else {
            this._moduleGlobalService.setParentUrl(window.location.pathname);
            this._moduleManagersService.goToModule(this.user.id, relevantExecution, 'overview', true);
        }
    }

    bookCourse(url: string) {
        // If the url starts with the same domain as the custom domain (whole one, not just base domain) then open internally
        if (url.includes(window.location.host)) {
            window.open(`${url}`, '_self');
        } else {
            window.open(url, '_blank');
        }
    }
}
